import script from "./SettingsItemCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemCategories.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemCategories.vue?vue&type=style&index=0&id=46f4fd31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f4fd31"]])

export default __exports__